import React from 'react';
import { BaseLink } from '../link/base-link';
import { AlertLink } from './alert-interface';

/**
 * Create a link to show in alerts
 *
 * @param config AlertLink config
 * @param className any className to apply to the link (used for margins)
 *
 * @return JSX of alert link
 */
export const createActionLink = (config: AlertLink, className: string) => (
  <BaseLink
    tabIndex={0}
    ref={config.ref}
    className={className}
    href={config.link}
    target={config.openLinkInNewTab ? '_blank' : undefined}
    onClick={config.onClick}
    onKeyDown={(event) => {
      if (event.key === 'Enter' && config.onEnter) {
        config.onEnter(event);
      }
    }}
    rel="noreferrer"
  >
    {config.label}
  </BaseLink>
);

/**
 * Get path to the svg illustration from radiant-styles module
 *
 * @param filename svg file name
 */
export const getMutedAlertSVGPath = (filename: string) =>
  `/node_modules/@thoughtspot/radiant-styles/public/img/illustrations/${filename}.svg`;
